import {
    Grid,
    TableCell,
    TableRow,
    Typography
} from '@mui/material';
import { WithdrawalBeneficiaryDetailTypeEnum, WithdrawalBeneficiaryDetailTypeMap } from '@tassat/common-definitions';
import React from 'react';

import { BeneficiaryEntityDetailsProps } from './types';
import { renderFields } from '../helper';
import { muiStyles } from '../styles';
import { WithdrawalInstructionFields } from '../types';

const entityDetailsFields: Record<WithdrawalBeneficiaryDetailTypeEnum, WithdrawalInstructionFields> = {
    [WithdrawalBeneficiaryDetailTypeEnum.BENEFICIARY]: [
        {
            label: 'Name',
            valueProp: 'BeneName'
        },
        {
            label: 'Account Number',
            valueProp: 'BeneBankAcct'
        },
        {
            label: 'Street Address',
            valueProp: 'BeneStreetAddress'
        },
        {
            label: 'City',
            valueProp: 'BeneCity'
        },
        {
            label: 'State/Province',
            valueProp: 'BeneStateProv',
            optional: true
        },
        {
            label: 'Postal Code',
            valueProp: 'BenePostalCode',
            optional: true
        },
        {
            label: 'Country',
            valueProp: 'BeneCountry'
        }
    ],
    [WithdrawalBeneficiaryDetailTypeEnum.BENEFICIARY_BANK]: [
        {
            label: 'Name',
            valueProp: 'BeneBankName'
        },
        {
            label: 'Account Type',
            valueProp: 'BeneBankAccountType'
        },
        {
            label: 'ABA Number',
            valueProp: 'BeneBankRoutNum',
            optional: true
        },
        {
            label: 'SWIFT BIC',
            valueProp: 'BeneBankBic',
            optional: true
        },
        {
            label: 'Street Address',
            valueProp: 'BeneBankStreetAddress'
        },
        {
            label: 'City',
            valueProp: 'BeneBankCity'
        },
        {
            label: 'State/Province',
            valueProp: 'BeneBankStateProv',
            optional: true
        },
        {
            label: 'Postal Code',
            valueProp: 'BeneBankPostalCode',
            optional: true
        },
        {
            label: 'Country',
            valueProp: 'BeneBankCountry'
        }
    ],
    [WithdrawalBeneficiaryDetailTypeEnum.INTERMEDIARY_BANK]: [
        {
            label: 'Name',
            valueProp: 'IntermediaryBankName'
        },
        {
            label: 'ABA Number',
            valueProp: 'IntermediaryBankRoutNum',
            optional: true
        },
        {
            label: 'SWIFT BIC',
            valueProp: 'IntermediaryBankBic',
            optional: true
        },
        {
            label: 'Street Address',
            valueProp: 'IntermediaryBankStreetAddress'
        },
        {
            label: 'City',
            valueProp: 'IntermediaryBankCity'
        },
        {
            label: 'State/Province',
            valueProp: 'IntermediaryBankStateProv',
            optional: true
        },
        {
            label: 'Postal Code',
            valueProp: 'IntermediaryBankPostalCode',
            optional: true
        },
        {
            label: 'Country',
            valueProp: 'IntermediaryBankCountry'
        }
    ],
    [WithdrawalBeneficiaryDetailTypeEnum.ADDITIONAL_INFO]: [],
    [WithdrawalBeneficiaryDetailTypeEnum.BLOCKCHAIN]: [
        {
            label: 'Blockchain',
            valueProp: 'Blockchain'
        },
        {
            label: 'Address',
            valueProp: 'Address'
        }
    ]
};

export const BeneficiaryEntitiyDetails: React.FC<BeneficiaryEntityDetailsProps> = (props) => {
    const {
        displayComponent,
        entityType,
        withdrawalInstruction
    } = props;

    const classes = muiStyles(props);

    const entityFields = entityDetailsFields[entityType];
    const isEntityEmpty = entityFields.length > 0 &&
        entityFields.every((field) => !withdrawalInstruction[field.valueProp]);

    if (isEntityEmpty) {
        const entityDisplayName = Object.values(WithdrawalBeneficiaryDetailTypeMap)
            .find((type) => type.value === entityType)?.displayValue ?? '';
        const emptyMessage = `No ${entityDisplayName}`;

        if (displayComponent === 'Table') {
            return (
                <TableRow className={classes.tableRow}>
                    <TableCell
                        className={classes.tableCell}
                        colSpan={2}
                    >
                        {emptyMessage}
                    </TableCell>
                </TableRow>
            );
        }

        return (
            <Grid
                className={classes.detailRow}
                container
                direction='row'
                justifyContent='space-between'
                spacing={0}
                wrap='nowrap'
            >
                <Typography
                    className={classes.labelFont}
                    variant='body2'
                >
                    {emptyMessage}
                </Typography>
            </Grid>
        );
    }

    return (
        <>
            {renderFields(withdrawalInstruction, entityDetailsFields[entityType], classes, displayComponent)}
        </>
    );
};